import { type TableHeaderProps, TableHeader } from '@shared/table-generator';

interface QSetSimilarityMatrixHeaderProps {
  columns: TableHeaderProps['columns'];
  columnSlotProps: TableHeaderProps['slotProps'];
}

export default function QSetSimilarityMatrixHeader(
  props: Readonly<QSetSimilarityMatrixHeaderProps>,
) {
  const { columns, columnSlotProps } = props;
  return <TableHeader columns={columns} slotProps={columnSlotProps} />;
}
